import { SessionBackend } from '../../../../frontend/src/app/core/session/session';
import { WorkspaceComboBackend } from '../../../../frontend/src/app/core/workspace/workspace';
import { IdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const AdminGate = {
  resource: ResourceName.admin,
  actions: {
    getSessionList: 'get-recording-list',
    updateWorkspacePublicSubdata: 'update-workspace-public-subdata',
    getWorkspace: 'get-workspace',
    getWorkspaceList: 'get-workspace-list',
  },
};

export type AdminGateActionTypes = {
  updateWorkspacePublicSubdata: {
    request: UpdateWorkspacePublicSubdataRequest;
    response: any;
  };
  getSessionList: {
    request: GetSessionListRequest;
    response: SessionBackend[];
  };
  getWorkspace: {
    request: IdRequest;
    response: any;
  };
  getWorkspaceList: {
    request: {
      email: string;
    };
    response: WorkspaceComboBackend[];
  };
};

export interface UpdateWorkspacePublicSubdataRequest {
  workspaceId: string;
  publicSubdata: any;
}

export interface GetSessionListRequest {
  userId: string;
}
